export enum NotificationSeverity {
  Error = "error",
  Warning = "warning",
  Info = "info",
  Success = "success",
}
